module.exports = __webpack_public_path__ + "img/logo-zhuigeng.c320dd18.png";